<script lang="ts">
	import type { Price } from '$lib/components/types';
	import type { ClassValue } from 'svelte/elements';
	import Link from '$lib/components/atoms/link/Link.svelte';
	import CardTitle from '$lib/components/recommendation/getyourguide/GetYourGuideCardTitle/GetYourGuideCardTitle.svelte';
	import RecommendationCardTemplate from '$lib/components/recommendation/RecommendationCardTemplate.svelte';
	import { getLanguageCode } from '$lib/i18n/language';
	import { formatPrice } from '$lib/utils/formatPrice';
	import * as m from '$paraglide/messages';

	interface Props {
		bookUrl?: string;
		imageUrl?: string;
		isHovered?: boolean;
		name?: string;
		price?: Price;
		isLoading?: boolean;
		reviewText?: string;
		class?: ClassValue;
		onBookClick?: () => void;
		onCardClick?: () => void;
	}

	const {
		bookUrl = '',
		imageUrl,
		isHovered = false,
		name = '',
		price,
		isLoading = false,
		reviewText,
		class: classes,
		onBookClick,
		onCardClick,
	}: Props = $props();

	const icon = 'gyg';
	const scheme = 'tourism';
</script>

<RecommendationCardTemplate
	{icon}
	{isHovered}
	{imageUrl}
	{isLoading}
	isSquare
	{onCardClick}
	class={classes}
>
	{#snippet title()}
		<CardTitle {name} {scheme} titleOnTwoLines />
	{/snippet}
	{#snippet rate()}

		{#if reviewText}
			<span class="truncate">{reviewText}</span>
		{/if}

	{/snippet}
	{#snippet buttons()}
		<Link
			button="filled"
			color="light"
			size="sm"
			href={bookUrl}
			target="_blank"
			rel="external"
			class="w-full"
			icon="open-in-new"
			label={price
				&& m.poi_card__book_min_price({
					price: formatPrice({
						amount: price.amount,
						currency: price.currency,
						language: getLanguageCode(),
					}),
				})}
			onclick={() => onBookClick?.()}
		/>

	{/snippet}
</RecommendationCardTemplate>
